import React from "react";
import styled from "@emotion/styled";
import { useReportMonk } from "../../context/reportMonk";
import useAuth from "../../utils/useAuth";
import { columns } from "./Table/columns";
import ResultTable from "./Table/ResultTable";
import ReportChart from "./ReportChart";
import { CustomSelect } from "../CustomFields";
import { Select } from "antd";
import { SelectLabel, SelectContainer } from "./shareStyledComponents";

const { Option } = Select;

const SummaryTabResult = () => {
  const {
    getTotalInformWeek,
    getWeekNumber,
    getDataTable,
    changeChartView,
    chartView,
  } = useReportMonk();
  const { classNo, roomNo, nickname, firstname } = useAuth();
  return (
    <div style={{ width: "100%" }}>
      <IntroBlock>
        ชื่อ <SpanDotted>{firstname}</SpanDotted>
        &nbsp;&nbsp; ชื่อเล่น <SpanDotted>{nickname}</SpanDotted>
        &nbsp;&nbsp; ชั้น <SpanDotted>{classNo}</SpanDotted> &nbsp;&nbsp; ห้อง{" "}
        <SpanDotted>{roomNo}</SpanDotted>
      </IntroBlock>
      <IntroBlock>
        จำนวนข้อมูลที่กรอก <SpanDotted>{getTotalInformWeek()}</SpanDotted>{" "}
        สัปดาห์ &nbsp;&nbsp;ผลสัปดาห์ที่{" "}
        <SpanDotted>{getWeekNumber("start")}</SpanDotted> ถึง สัปดาห์ที่{" "}
        <SpanDotted>{getWeekNumber("end")}</SpanDotted>
      </IntroBlock>

      <ResultTable
        columns={columns}
        dataSource={getDataTable("dataSource")}
        mean={getDataTable("mean")}
        sd={getDataTable("sd")}
        median={getDataTable("median")}
      />
      <div style={{ display: "flex", justifyContent: "center" }}>
        <SelectContainer style={{ marginTop: "48px" }}>
          <SelectLabel>ดูในมุมมองกราฟตามหมวด</SelectLabel>
          <br />
          <CustomSelect
            placeholder="เลือกมุมมอง"
            width={"440px"}
            widthRs={"100%"}
            onChange={changeChartView}
            defaultValue={chartView}
          >
            <Option value={"cowMilkScore"}>ดื่มดี นมวัว</Option>
            <Option value={"vegetableScore"}>สุขชัวร์ เพิ่มผัก</Option>
            <Option value={"exerciseScore"}>รัก ออกกำลังกาย</Option>
            <Option value={"sweetDrinkScore"}>หยุดยั้ง น้ำหวาน</Option>
            <Option value={"total4D"}>คะแนนรวม</Option>
          </CustomSelect>
        </SelectContainer>
      </div>

      <ReportChart />
    </div>
  );
};

const IntroBlock = styled.div`
  margin-left: 8px;
  margin-right: 8px;
  margin-bottom: 10px;
`;
const SpanDotted = styled.span`
  border-bottom: 2px dotted #000;
  min-width: 30px;
  display: inline-grid;
  text-align: center;
`;

export default SummaryTabResult;
